import BusinessActivityTabComponent from './BusinessActivityTab';

export const BusinessActivityTab = BusinessActivityTabComponent;
